import "./image-content.scss";
